import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { getWriters } from '@blocks/api';
import { STORAGE_ORDER } from '@blocks/constants';
import { IWriter } from '@blocks/types/writers';
import { isBrowser } from '@blocks/utils';
import getDefaultStorage from '@blocks/utils/getDefaultStorage';

interface IRequestedWriterStore {
  writer?: IWriter;
  isWriterLoading: boolean;
  clearWriter: () => void;
  fetchWriter: (id: { domain: string; writer_req_slug: string }) => void;
}

export const useRequestedWriterStore = create<IRequestedWriterStore>()(
  persist(
    set => ({
      writer: undefined,
      isWriterLoading: false,
      clearWriter: () => set({ writer: undefined }),
      fetchWriter: id => {
        set({ isWriterLoading: true });
        const { domain, writer_req_slug } = id;
        if (isBrowser()) {
          // @todo: remove ts-ignore after ts api integration
          // @ts-ignore
          getWriters({ domain, writers: [writer_req_slug] })
            .then(res => {
              set({ writer: res[writer_req_slug] });
            })
            .finally(() => {
              set({ isWriterLoading: false });
            });
        }
      },
    }),

    {
      name: 'requested-writer',
      storage: createJSONStorage(() => getDefaultStorage()),
    },
  ),
);

interface IOrderStore {
  order: {
    login?: string;
    writer_req_slug?: string;
    discipline_sub?: string;
    paper_type?: number;
    pages_qty?: number;
    words_qty?: number;
    deadline_datetime?: string;
    title?: string;
  };
  setOrderAction: (fields: { writer_req_slug?: string; paper_type?: number }) => void;
  clearOrderStore: () => void;
  clearLogin: () => void;
}

const initialOrderState = {
  writer_req_slug: '',
};

export const useOrderStore = create<IOrderStore>()(
  persist(
    set => ({
      order: {
        writer_req_slug: '',
      },
      setOrderAction: fields => set(state => ({ order: { ...state.order, ...fields } })),
      clearOrderStore: () => set({ order: { ...initialOrderState } }),
      clearLogin: () => set(state => ({ order: { ...state.order, login: undefined } })),
    }),
    {
      name: STORAGE_ORDER,
      storage: createJSONStorage(() => getDefaultStorage()),
    },
  ),
);

export const clearStorage = () => {
  useOrderStore.getState().clearOrderStore();
  useRequestedWriterStore.getState().clearWriter();
};
